import React from 'react';
import Demo from '../StudentInterview/container/StudentInterview';

export default [
    {
        path: '/demo',
        exact: true,
        component: () => <Demo />
    }
];